// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IDeleteFoldersRequest,
  TDeleteFoldersModel,
  IMappers,
  TDeleteFoldersResponse,
  IDeleteFoldersResponseError,
} from './types';

export const defaultConfig: TDeleteFoldersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/delete-folders/',
  requestType: 'json',
} as TDeleteFoldersModel;

export function createDeleteFoldersModel(parameters: IDeleteFoldersRequest): TDeleteFoldersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteFoldersOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: IDeleteFoldersRequest;
}

export async function fetchDeleteFolders<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteFoldersOptions<TResponse400>): Promise<TDeleteFoldersResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createDeleteFoldersModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IDeleteFoldersResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDeleteFoldersResponse;
}
